export default "__VITE_ASSET__BidkIpO4__"